/** Deep merge for plain-object trees (i18n resources). Later sources win; arrays are replaced. */
type Tree = Record<string, unknown>

const isPlain = (v: unknown): v is Tree =>
  typeof v === 'object' && v !== null && !Array.isArray(v)

export function deepMerge<T extends object>(...sources: object[]): T {
  const out: Tree = {}
  for (const src of sources) {
    for (const [k, v] of Object.entries(src)) {
      out[k] = isPlain(v) && isPlain(out[k]) ? deepMerge(out[k] as Tree, v) : isPlain(v) ? deepMerge(v) : v
    }
  }
  return out as T
}
